import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { PROD_53, QA_53 } from '../constants/Portals';
export const isHubSpotBETPortal = () => {
  const portalNumber = PortalIdParser.get();
  const isProd = enviro.isProd();
  return isProd ? portalNumber === PROD_53 : portalNumber === QA_53;
};